import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SurveyResultsFilterNames } from 'models';
import { IFilterChangePayload } from 'modules/admin-panel/pages/results/models';
import {
	getFromSessionStorage,
	SessionStorageKeyTypes,
} from 'utils/clientStorage';
import {
	calculatedRoundsSelector,
	statisticGroupingTypeSelector,
} from 'modules/admin-panel/pages/results/selectors/dashboard.selectors';
import { setActiveBusinessUnit } from 'modules/admin-panel/pages/results/results.actions';
import { useSurveyResultsFilter } from '../useSurveyResultsFilter';

export const useSetActiveBusinessUnit = () => {
	const dispatch = useDispatch();
	const {
		onChangeSurveyResultsFilter,
		surveyFilter,
	} = useSurveyResultsFilter();
	const surveyId = getFromSessionStorage(
		SessionStorageKeyTypes.dashboardSurveyId,
	);
	const rounds = useSelector(calculatedRoundsSelector);
	const groupingType = useSelector(statisticGroupingTypeSelector);

	const boundSetActiveBusinessUnit = useCallback(
		(p: IFilterChangePayload) => dispatch(setActiveBusinessUnit(p)),
		[dispatch],
	);

	return useCallback(
		(curBusinessUnit?: string) => {
			boundSetActiveBusinessUnit({
				rounds,
				surveyId,
				...surveyFilter,
				businessUnit: curBusinessUnit,
				groupingType,
			});
			onChangeSurveyResultsFilter({
				[SurveyResultsFilterNames.businessUnit]: curBusinessUnit,
			});
		},
		[
			boundSetActiveBusinessUnit,
			rounds,
			surveyId,
			groupingType,
			onChangeSurveyResultsFilter,
			surveyFilter,
		],
	);
};
